// series-7 (C.6, #491, 24-sep-2026): BUSCAR Y ORDENAR POR NOMBRE DENTRO DE UNA
// TARJETA PLEGABLE ABIERTA (la padre de las partes y la del grupo del profe).
//
// ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).
//
// La regla del diseno (3.7): el texto filtra por CONTENIDO en el nombre mostrado,
// sin distinguir mayusculas ni acentos; vacio (o solo espacios) = todas. Funciones
// puras: no tocan la lista que reciben.

// Las marcas diacriticas combinantes que deja la descomposicion canonica (NFD).
const DIACRITICOS = /[\u0300-\u036f]/g;

/** El nombre sin acentos y en minusculas, para comparar. */
export function normalizar(texto) {
  if (texto === undefined || texto === null) return '';
  return String(texto).normalize('NFD').replace(DIACRITICOS, '').toLowerCase();
}

/** Si `nombre` contiene lo escrito. Lo escrito vacio (o solo espacios) coincide siempre. */
export function coincide(nombre, escrito) {
  const buscado = normalizar(escrito).trim();
  if (!buscado) return true;
  return normalizar(nombre).includes(buscado);
}

/** Las que coinciden, en el orden en que llegan (una copia, nunca la misma lista). */
export function filtrarPorNombre(lista, escrito, nombreDe) {
  return (Array.isArray(lista) ? lista : []).filter((x) => coincide(nombreDe(x), escrito));
}

/** Comparacion de dos nombres sin distinguir acentos ni mayusculas. */
export function compararNombres(a, b, idioma) {
  const x = a === undefined || a === null ? '' : String(a);
  const y = b === undefined || b === null ? '' : String(b);
  return x.localeCompare(y, idioma || undefined, { sensitivity: 'base' });
}

/**
 * El orden de la tarjeta del grupo (C15): "recientes" deja el orden en que llega
 * (el del servidor, que ya es el de hoy); "az" y "za" ordenan por nombre, con lo que
 * `vaAlFondo` marque (las caducadas) siempre abajo y ordenado igual entre si. Los
 * empates quedan en el orden en que llegan.
 */
export function ordenarPorNombre(lista, orden, nombreDe, vaAlFondo = () => false, idioma) {
  const copia = Array.isArray(lista) ? lista.slice() : [];
  if (orden !== 'az' && orden !== 'za') return copia;
  const signo = orden === 'za' ? -1 : 1;
  const arriba = [];
  const abajo = [];
  copia.forEach((x) => (vaAlFondo(x) ? abajo : arriba).push(x));
  const porNombre = (a, b) => signo * compararNombres(nombreDe(a), nombreDe(b), idioma) || 0;
  return [...arriba.sort(porNombre), ...abajo.sort(porNombre)];
}
